import React from "react";
import classnames from "classnames";
import pluralize from "pluralize";
import TimeAgo from "react-timeago";

const LastUpdatedTime: React.FC<{
  className?: string;
  lastMenuUpdate: string;
  totalItems: number;
}> = ({ className, lastMenuUpdate, totalItems }) => {
  if (!lastMenuUpdate) {
    return null;
  }

  const itemCount = !!totalItems && pluralize("product", totalItems, true);
  const label = itemCount ? `${itemCount} | ` : "";

  return (
    <div
      data-testid="last-updated-time"
      className={classnames("font-bold lg:text-right text-xs", className)}
    >
      {label} Last updated: <TimeAgo date={lastMenuUpdate} />
    </div>
  );
};

export default LastUpdatedTime;
